import styled from 'styled-components';
import { SummaryDetailsModal, SummaryMoreDetailsWrapper } from './ModalStyles';

const ActionButtons = styled.div`
  right: ${(props) => props?.right || '20px'};
  bottom: ${(props) => props?.bottom || '24px'};
  z-index: 500;
  position: ${(props) =>
    props?.absolute ? 'absolute' : props?.position || 'static'};
`;

export { SummaryDetailsModal, SummaryMoreDetailsWrapper, ActionButtons };
